export default __webpack_public_path__ + "static/media/6.04396631.jpg";